import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var orderDetailRoute = [{
  path: "order-detail/:orderNumber",
  name: "orderDetail",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./order-detail.vue");
  }
}];